import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { IFilterStoreProps } from '@legacy/reducers/FilterReducer';
import { getFetch } from '@legacy/utils/fetcher';
import { concatQueries } from '@legacy/utils/url';
import { filterURLParams } from '@legacy/apis/utils/ParamsFilter';
import { IMoveHoursWrapper } from '../types';

const MOVE_HOURS_URL_PATH = '/api/v2/adjustments/move-hours';
export const MOVE_HOURS_MSW_STATUS_KEY = 'GetMoveHoursAPI';
export const MOVE_HOURS_KEY = 'MOVE_HOURS';

interface IParams {
  [key: string]: string;
}

const moveHoursFetch = (
  filters: string,
  params: { [key: string]: string },
): Promise<IMoveHoursWrapper> =>
  getFetch({
    path: `${MOVE_HOURS_URL_PATH}${concatQueries(
      Object.keys(params).map((key) => ({
        param: key.replaceAll('-', ''),
        value: params[key],
      })),
    )}`.concat(filters),
    key: MOVE_HOURS_MSW_STATUS_KEY,
  });

export const useGetMoveHours = (
  { selectedFilterList }: Pick<IFilterStoreProps, 'selectedFilterList'>,
  params?: IParams,
) => {
  const { filteredList, filteredParams } = filterURLParams(
    selectedFilterList,
    params,
  );

  const { data, ...restProps } = useQuery({
    queryKey: [MOVE_HOURS_KEY, params || {}, selectedFilterList || {}],

    queryFn: async () => {
      const response = await moveHoursFetch(filteredList, filteredParams || {});
      return response;
    },

    placeholderData: keepPreviousData,
    staleTime: 2000,
  });

  const {
    totalRegisteredHours,
    isCommentMandatory,
    isShowingProjectNo,
    isShowingTaskNo,
    additionalCommentFieldName,
  } = data?.properties || {};

  const summations = {
    id: 'TOTAL',
    registeredHours: totalRegisteredHours ?? '0',
  };

  return {
    data: data?.entities?.map((item) => ({
      ...item.properties,
    })),
    summations,
    additionalCommentLabel: additionalCommentFieldName ?? '',
    isCommentMandatory: isCommentMandatory ?? false,
    isShowingProjectNo: isShowingProjectNo ?? false,
    isShowingTaskNo: isShowingTaskNo ?? false,
    isEmpty: (data?.entities?.length ?? 0) === 0,
    ...restProps,
  };
};
